<template>
    <div class="relative-position">
        <q-carousel keep-alive v-model="slide" swipeable animated infinite :autoplay="10000" class="no-shadow" height="250px">
            <q-carousel-slide :name="index + 1" class="column no-wrap" :img-src="s.image" v-for="(s, index) in filteredSlides" :key="index">
            </q-carousel-slide>
        </q-carousel>

        <q-inner-loading :showing="loading">
            <q-spinner-facebook size="1rem" color="text-blue-grey-4" />
        </q-inner-loading>
    </div>
</template>

<script>
export default {
    name: 'HomeCarouselCoursesMobile',

    i18nOptions: { namespaces: ['custom', 'common', 'campaigns'] },

    data() {
        return {
            slide: 1,
            slides: [],
            loading: false
        }
    },

    computed: {
        filteredSlides() {
            return this.slides.filter(e => e.status === 1)
        }
    },

    methods: {
        getCampaings() {
            this.loading = true

            this.$axios.get(`/etraining_rewards/campaigns/`)
            .then(response => {
                this.slides = response.data
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        showCampaign(s) {
            if (this.$route.name === 'campaigns') {
                this.$emit('campaignClicked', s.id)
            }
            else {
                this.$router.push({ name: 'campaigns', params: { campaign: s.id } })
            }
        }
    },

    created() {
        this.getCampaings()
    }
}
</script>

<style lang="scss" scoped>
.title {
	line-height: 3.125rem;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.description {
	line-height: 1rem;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
</style>